<template>
  <div class="text-[0.8em] mr-2 text-center">
    <template v-if="config.camera.status.camera_mode == 0">
      {{ config.camera.status.remain_photo_num }} <br />{{ $e("photo") }}
    </template>
    <template v-if="config.camera.status.camera_mode == 1">
      {{ recordTime(config.camera.status.remain_record_duration) }}s
      <br />{{ $e("restantes") }}
    </template>
  </div>
</template>
<script>
export default {
  name: "Mode_Remain",
  props: {
    config: {
      config: Object,
      video: Object,
    },
  },
  setup() {
    return {};
  },
  methods: {
    recordTime(secondes) {
      return (
        (secondes < 600 ? "0" : "") +
        Math.floor(secondes / 60) +
        " : " +
        (secondes % 60 < 10 ? "0" : "") +
        (secondes % 60)
      );
    },
  },
};
</script>
